<template>
  <Flex v-if="selectedValue" absolute right-0 mx-1 clear-selection>
    <Icon src="material/clear" class="cursor-pointer" @click="clearSelection" />
  </Flex>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex'
import Icon from '@wizer/core/components/icon/Icon'

export default {
  name: 'ClearSelector',
  components: {
    Flex,
    Icon,
  },
  props: {
    selectedValue: String,
    attributeToClear: String,
  },
  methods: {
    clearSelection() {
      const newRoute = {
        name: this.$route.name,
        query: {
          ...this.$route.query,
        },
      }
      newRoute.query[this.attributeToClear] = ''
      this.$router.push(newRoute)
    },
  },
}
</script>

<style lang="postcss" scoped>
.series-options .clear-selection,
.location-options .clear-selection {
  visibility: hidden;
}
.series-options:hover .clear-selection,
.location-options:hover .clear-selection {
  visibility: visible;
}
</style>
